module.exports = __webpack_public_path__ + "img/loading.ae1f68cb.gif";